var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.actionImmediate)?_c('div',{staticClass:"timer loading"},[_vm._v(" You will be redirected in"),_c('span',[_vm._v(".")]),_c('span',[_vm._v(".")]),_c('span',[_vm._v(".")]),_vm._v(" "+_vm._s(_vm.timeLeft)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }